import React, { Component } from 'react'
import {BrowserRouter as Router} from "react-router-dom"
import Header from "./Header"
import Section from "./Section"


export class Main extends Component {
    render() {
        return (
            <div>
                <Router>
                    <Header/>
                    <Section/>
                    <footer style={{ textAlign: "center", color:"white", height:"35px", fontWeight:"bold", fontSize:"20px", backgroundColor:"#17a2b8" }}>Copyright 2021 - Desain by Hamdani</footer>
                </Router>
            </div>
        )
    }
}

export default Main
